module.exports = __webpack_public_path__ + "img/smubia.94045bed.png";